/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';

import * as authActions from '~store/user/actions/auth';

import Input from '../Input';
import Colors from '~global/Colors';
import { isNative } from '~global/screens';

const OtpInputs = ({
  pinCount: propsPinCount,
  getValues,
  getOtp,
  statusOtp,
  ...props
}) => {
  const inputsOtp = useRef([]);
  const dispatch = useDispatch();
  const isResetOtp = useSelector((state) => state.auth.isResetOtp);

  const pinCountDefault = propsPinCount
    ? Array(propsPinCount).fill(null)
    : Array(6).fill(null);
  const [otp, setOtp] = useState(pinCountDefault);
  // eslint-disable-next-line no-unused-vars
  const [pinCount, setPinCount] = useState(pinCountDefault);

  useEffect(() => {
    const copyOtp = [...otp];
    if (getValues) {
      const filterValues = copyOtp.toString().replace(/[,]/gi, '');
      getValues(filterValues);
    }
    if (getOtp) {
      getOtp(otp);
    }
  }, [otp]);

  useEffect(() => {
    if (isResetOtp) {
      setOtp(pinCount);
      dispatch(authActions.setResetOTP(false));
    }
  }, [isResetOtp]);

  useEffect(() => {
    if (statusOtp) {
      setOtp(pinCountDefault);
    }
  }, [statusOtp]);

  useEffect(() => {
    resetOtpValues();
  }, []);

  const addDataOtp = ({ key, value }) => {
    const copyOtp = [...otp];
    copyOtp[key] = value;
    setOtp(copyOtp);
  };

  const removeOtp = (key) => {
    const copyOtp = [...otp];
    copyOtp[key] = '';
    setOtp(copyOtp);
  };

  const focusToNextInput = (value, key) => {
    addDataOtp({ key, value });
    if (key < pinCountDefault.length - 1 && value) {
      inputsOtp.current[key + 1].focus();
    }
    if (key === pinCountDefault.length - 1) {
      inputsOtp.current[key].value = '';
      setTimeout(() => inputsOtp.current[key].blur(), 100);
    }
  };

  const focusToPreviousInput = (e, key) => {
    const inputCurrent = inputsOtp.current[key - 1];
    if (e.key === 'Backspace' && key !== 0) {
      removeOtp(key);
      setTimeout(() => inputCurrent.focus(), 100);
    }
  };

  const resetOtpValues = () => {
    setOtp(pinCountDefault);
  };

  return (
    <View style={styles.formWrapperOtp}>
      {otp.map((pinCountValue, key) => (
        <View
          style={[
            styles.formGroup,
            propsPinCount ? { width: 100 / propsPinCount + '%' } : {},
          ]}
          key={key}>
          <Input
            secureTextEntry
            {...props}
            key={`inputOtp_${key}`}
            placeholder=""
            maxLength={1}
            keyboardType="numeric"
            style={StyleSheet.flatten([styles.formInputText])}
            inputContainerStyle={{
              ...styles.inputContainerStyle,
              ...props?.inputContainerStyle,
            }}
            onChangeText={(value) => focusToNextInput(value, key)}
            onKeyPress={(e) => focusToPreviousInput(e.nativeEvent, key)}
            isInputsOtp
            inputRef={(ref) => (inputsOtp.current[key] = ref)}
            value={pinCountValue || ''}
          />
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  inputContainerStyle: {
    paddingHorizontal: 3,
    backgroundColor: Colors.white,
    borderWidth: 1,
    height: 44,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: Colors.grey0,
  },
  inputContainerStyleFilled: {
    borderColor: Colors.purple14,
  },
  formInputText: {
    textAlign: 'center',
    fontSize: 38,
    lineHeight: 20,
    letterSpacing: 0,
    padding: 0,
    fontFamily: 'figtree-medium',
    ...(!isNative && { width: 38 }),
  },
  formWrapperOtp: {
    position: 'relative',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: -3,
    marginRight: -3,
    marginBottom: 24,
  },
  formGroup: {
    width: '16.6666666666%',
    paddingHorizontal: 3,
  },
});

export default OtpInputs;
